/**
 * Created by Yoyo on 09/23/2019.
 * Description:
 * note-tile settings on dashboard in edit workflow
 * ------ maintenance history ------
 */

import { Component, OnInit, Input, ChangeDetectionStrategy, OnChanges, SimpleChanges } from '@angular/core';
import { Validatable } from '../../tile-choose-visualization/tile-choose-visualization.model';
import { TileModel, TilePageDesc, TileSorts, } from '../../../../../tamalelibs/models/tile.model';
import { PROPERTY_FIELD_MAP, PAGE_LAYOUT_SETTINGS, DEFAULT_SETTINGS_DATA } from './note-tile-chart-setting.model';
import { NoteTileSettingsService } from './note-tile-chart-setting.service';
import * as _lodash from 'lodash';

@Component({
    selector: 'tam-note-tile-chart-setting',
    templateUrl: './note-tile-chart-setting.component.html',
    styleUrls: ['./note-tile-chart-setting.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NoteTileChartSettingComponent implements OnInit, Validatable, OnChanges {
    // for changes of dashboard tile, to be passed by api request
    @Input() config: TileModel;
    // for display settings to user, synchronized to this.config but not used by api request
    data: any = _lodash.cloneDeep(DEFAULT_SETTINGS_DATA);
    // settings for component layout
    settings: any = [];

    constructor() {
        this.settings = _lodash.cloneDeep(PAGE_LAYOUT_SETTINGS);
        for (let i = 0; i < this.settings[1].fields.length; i++) {
            const fieldName = PROPERTY_FIELD_MAP.get(this.settings[1].fields[i].propertyName);
            this.settings[1].fields[i].value = NoteTileSettingsService.cloneColumnByfield(fieldName);
        }
    }

    ngOnInit() { }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.config.currentValue) {
            const value = NoteTileSettingsService.prepareNoteTileOnlyFields(changes.config.currentValue, DEFAULT_SETTINGS_DATA);
            const extendData = NoteTileSettingsService.threadTileConfig2DisplaySettings(value);
            this.data = Object.assign({}, this.data, extendData);
        }
    }

    getStyle(field) {
        return {
            'grid-area': field.row + '/' + field.col + '/' + field.row + '/' + (field.col + field.width - 1)
        };
    }

    validate() {
        return this.data['threadsCount'] > 0 && this.data['threadsDisplayModes'] &&
            typeof this.data['threadsShowFullThread'] === 'boolean' && this.data['threadsOrder'];
    }

    onValueChanged($event, id) {
        switch (id) {
            case 1:
                if (!this.config.pageDesc) {
                    this.config.pageDesc = new TilePageDesc(0, 1);
                }
                this.config.pageDesc.rpp = $event;
                break;
            case 2:
                this.config.options.parentOrLastSidenote = $event;
                break;
            case 3:
                this.config.options.showFullThread = $event === true;
                // this.settings[0].fields[1].disabled = $event === true;
                break;
            case 4:
                if (!this.config.sorts) {
                    this.config.sorts = new TileSorts('', 'desc');
                }
                this.config.sorts.field = $event;
                break;
        }
    }

    onCheckboxChange(value, id) {
        const items = this.settings[1].fields.filter((field) => field.id === id);
        const item = items.length > 0 ? items[0] : {};
        if (value) {
            this._checked(item.value, item.propertyName);
        } else {
            this._unchecked(item.value, item.propertyName);
        }
    }

    private _checked(column, propertyName) {
        if (column) {
            this.config = NoteTileSettingsService.pushColumn(this.config, column);
        } else {
            this.config = NoteTileSettingsService.setNoneColumns(this.config, propertyName, true);
        }
    }

    private _unchecked(column, propertyName) {
        if (column) {
            this.config = NoteTileSettingsService.popColumn(this.config, column);
        } else {
            this.config = NoteTileSettingsService.setNoneColumns(this.config, propertyName, false);
        }
    }
}
